import { useQuery } from "react-query";
import { uncoveryApi } from "../..";

const fetchMaps = async ({
  entityId,
  page,
  pageSize,
  sortBy,
  orderBy,
  status,
}) => {
  const query = `/entities/${entityId}/cartographies?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&orderBy=${orderBy}&status=${status}`;
  const { data } = await uncoveryApi.get(query);
  return data.data;
};

export default function useFetchMaps({
  entityId,
  page = 1,
  pageSize = 20,
  sortBy = "createdAt",
  orderBy = "desc",
  status = "",
  intervalMs = false,
}) {
  return useQuery(
    ["maps", entityId, page, pageSize, sortBy, orderBy, status],
    () =>
      fetchMaps({
        entityId,
        page,
        pageSize,
        sortBy,
        orderBy,
        status,
      }),
    {
      enabled: false,
      refetchInterval: intervalMs,
      retry: false,
    }
  );
}
